import { isMobileVersion } from './dom'

/**
 * 获取当前平台类型
 * @returns 'app' | 'web_h5' | 'web_pc'
 */
export const getPlatform = (): 'app' | 'web_h5' | 'web_pc' => {
  if (typeof navigator === 'undefined') return 'web_pc'

  const userAgent = navigator.userAgent.toLowerCase()

  // 判断是否为 App（根据 App WebView UserAgent 标识）
  if (userAgent.includes('tipsy-app') || userAgent.includes('tipsyapp')) {
    return 'app'
  }

  // 判断是否为移动端
  if (isMobileVersion()) {
    return 'web_h5'
  }

  return 'web_pc'
}
